module.exports = __webpack_public_path__ + "static/media/Artboard10.2e1f6515.png";